import { InputAdornment, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import SearchIcon from "../icons/Components/SearchIcon";

interface IProps {
  onSearch: (value: string) => void;
  color?: string;
}

const UploadSearch = (props: IProps) => {
  const { onSearch, color = "white" } = props;

  const [value, setValue] = useState<string>("");

  useEffect(() => {
    onSearch(value);
    // eslint-disable-next-line
  }, [value])

  return (
    <TextField
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder="Search"
      sx={{
        width: "100%",
        background: "transparent",
        "& label.Mui-focused": {
          color: "#D8DFEC"
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
          border: "1px solid rgba(216, 223, 236, 0.3)"
        },
        "& .MuiOutlinedInput-root": {
          borderRadius: "12px",
          color: color,
          border: "1px solid rgba(216, 223, 236, 0.3)",
          height: "50px"
        },
        "& .MuiFormHelperText-root.Mui-error": {
          margin: 0,
          marginTop: 5,
        }
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start' style={{ width: "fit-content", marginRight: "10px" }}>
            <SearchIcon/>
          </InputAdornment>
        )
      }}
    />
  );
};

export default UploadSearch;
